import { useIntl } from 'react-intl';

export const useQuickAllocationActions = ({ openReleaseResourcesDialog }) => {
  const intl = useIntl();

  const releaseResourcesAction = {
    label: intl.formatMessage({
      id: 'resourceRequestActions.releaseResources'
    }),
    onClick: openReleaseResourcesDialog
  };

  return [releaseResourcesAction];
};

export default useQuickAllocationActions;
